import React from 'react'

const IconUserManagement = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7508 28.438H11.2508C9.60079 28.438 8.22579 28.2755 7.06329 27.9255C6.63829 27.8005 6.36329 27.388 6.38829 26.9505C6.70079 23.213 10.4883 20.2754 15.0008 20.2754C19.5133 20.2754 23.2883 23.2005 23.6133 26.9505C23.6508 27.4005 23.3758 27.8005 22.9383 27.9255C21.7758 28.2755 20.4008 28.438 18.7508 28.438ZM8.40079 26.3255C9.22579 26.488 10.1633 26.563 11.2508 26.563H18.7508C19.8383 26.563 20.7758 26.488 21.6008 26.3255C20.9383 23.9255 18.2008 22.1504 15.0008 22.1504C11.8008 22.1504 9.06329 23.9255 8.40079 26.3255Z'
        fill='black'
      />
      <path
        d='M18.75 2.5H11.25C5 2.5 2.5 5 2.5 11.25V18.75C2.5 23.475 3.925 26.0625 7.325 27.025C7.6 23.775 10.9375 21.2125 15 21.2125C19.0625 21.2125 22.4 23.775 22.675 27.025C26.075 26.0625 27.5 23.475 27.5 18.75V11.25C27.5 5 25 2.5 18.75 2.5ZM15 17.7125C12.525 17.7125 10.525 15.7 10.525 13.225C10.525 10.75 12.525 8.75 15 8.75C17.475 8.75 19.475 10.75 19.475 13.225C19.475 15.7 17.475 17.7125 15 17.7125Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.9999 18.65C12.0124 18.65 9.5874 16.2125 9.5874 13.225C9.5874 10.2375 12.0124 7.8125 14.9999 7.8125C17.9874 7.8125 20.4124 10.2375 20.4124 13.225C20.4124 16.2125 17.9874 18.65 14.9999 18.65ZM14.9999 9.6875C13.0499 9.6875 11.4624 11.275 11.4624 13.225C11.4624 15.1875 13.0499 16.775 14.9999 16.775C16.9499 16.775 18.5374 15.1875 18.5374 13.225C18.5374 11.275 16.9499 9.6875 14.9999 9.6875Z'
        fill='black'
      />
    </svg>
  )
}

export default IconUserManagement
